export class DowntimePlan {
    constructor({
          id = null,
          locId= '', 
          locName= ``, 
          startDate= ``,
          endDate= ``,
          description= ``,  
          
          startDateStr= ``,
          endDateStr= ``,
      } = {}) {
      this.id = id;
      this.locId = locId;
      this.locName = locName;
      this.startDate = startDate;
      this.endDate = endDate;
      this.description = description;  
      
      this.startDateStr = startDateStr;
      this.endDateStr = endDateStr;
    }
  }
  export function gridFields() {
    return Object.freeze([ 
        {
            key: 'locName',
            label: 'lbl.downtimePlan.locName',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
          key: 'startDateStr',
          label: 'lbl.downtimePlan.startDate',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'endDateStr',
          label: 'lbl.downtimePlan.endDate',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'description',
          label: 'lbl.downtimePlan.description',
          form: {
            type: 'input'
          }
        }
    ]);
  }
  export const fields = Object.freeze(Object.keys(new DowntimePlan()).map(i => 'entity.' + i));

  export const filterFields = [
    'filter.locNameFilter',
    'filter.startDateFilter',
    'filter.endDateFilter'
  ];
  export const filter = {
    'locNameFilter': "",
    'startDateFilter': "",
    'endDateFilter': ""
  };